import styled from 'styled-components';
import { tvar } from '@versita/frontend/design-tokens';

export const StyledPopupListAnchor = styled.div`
  position: relative;
  display: inline-block;
`;

export const StyledPopupListButton = styled.button`
  background: transparent;
  border: none;
  cursor: pointer;
  display: inline-block;
`;

export const StyledPopupList = styled.div<{ $visible?: boolean }>`
  position: absolute;
  z-index: 100;
  display: ${({ $visible }) => ($visible ? 'flex' : 'none')};
  border: 0.1rem solid ${tvar('colors.neutrals.grey3')};
  padding: ${tvar('space.double')};
  background: ${tvar('colors.fill.primary')};
  flex-direction: column;
  top: calc(100% + ${tvar('space.single')});
  left: 50%;
  transform: translateX(-50%);
  width: max-content;
  gap: ${tvar('space.single')};
  box-shadow: 0 0.3rem 0.6rem rgba(0, 0, 0, 0.05);

  &:after {
    content: '';
    display: block;
    position: absolute;
    left: calc(50% - 1rem);
    top: -1rem;
    height: 2rem;
    width: 2rem;
    background: ${tvar('colors.fill.primary')};
    border-left: 0.1rem solid ${tvar('colors.neutrals.grey3')};
    border-top: 0.1rem solid ${tvar('colors.neutrals.grey3')};
    transform: rotate(45deg);
  }
`;
